import { render } from "./PostsByCategoryPage.vue?vue&type=template&id=2775d08e&ts=true"
import script from "./PostsByCategoryPage.vue?vue&type=script&lang=ts"
export * from "./PostsByCategoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__